import React from "react";
import { Box, Typography, Button } from "@mui/material";

const StatusPill = ({ status, onRepush }) => {
  const map = {
    launched: {
      label: "Launched",
      color: "#2ECC71",
      bg: "rgba(46,204,113,.13)",
    },
    pending: { label: "Pending", color: "#F1C40F", bg: "rgba(241,196,15,.13)" },
    stopped: { label: "Stopped", color: "#E74C3C", bg: "rgba(231,76,60,.13)" },
    completed: {
      label: "Completed",
      color: "#3498DB",
      bg: "rgba(52,152,219,.13)",
    },
  };

  const s = map[status] ?? {
    label: status ?? "—",
    color: "#666",
    bg: "rgba(0,0,0,.06)",
  };

  return (
    <Box sx={{ display: "inline-flex", alignItems: "center", gap: 1.5 }}>
      <Box
        sx={{
          display: "inline-flex",
          alignItems: "center",
          gap: 0.75,
          px: 1.25,
          py: 0.35,
          borderRadius: "20px",
          background: s.bg,
          border: `1px solid ${s.color}44`,
        }}
      >
        <Box
          sx={{
            width: 6,
            height: 6,
            borderRadius: "50%",
            background: s.color,
            boxShadow: `0 0 6px ${s.color}`,
            animation: status === "launched" ? "pulse 2s infinite" : "none",
            "@keyframes pulse": {
              "0%,100%": { opacity: 1 },
              "50%": { opacity: 0.3 },
            },
          }}
        />
        <Typography
          sx={{
            fontSize: 11,
            fontWeight: 700,
            color: s.color,
            fontFamily: "'IBM Plex Mono',monospace",
            letterSpacing: 0.5,
          }}
        >
          {s.label.toUpperCase()}
        </Typography>
      </Box>

      {status === "completed" && (
        <Button
          variant="outlined"
          size="small"
          onClick={onRepush}
          sx={{
            fontSize: 11,
            fontWeight: 600,
            fontFamily: "'IBM Plex Mono',monospace",
            textTransform: "none",
            borderRadius: "15px",
            py: 0.25,
            px: 1.5,
            borderColor: "#3498DB88",
            color: "#3498DB",
            "&:hover": {
              borderColor: "#3498DB",
              background: "rgba(52,152,219,.10)",
            },
          }}
        >
          Repush Unanswered
        </Button>
      )}
    </Box>
  );
};

export default StatusPill;
